import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { flowFiltersToSearch, parseFlowFilters } from '../../entities/flow';
import { useSession } from '../../entities/session';
import { FlowsPage } from '../../pages/flows';

export const Route = createFileRoute('/_shell/flows/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function FlowsRoute() {
    const navigate = useNavigate();
    const filters = parseFlowFilters(Route.useSearch());
    const session = useSession();

    return (
      <FlowsPage
        filters={filters}
        timeZone={session.data?.preferences.timezone}
        onFilters={(next) => void navigate({ to: '/flows', search: flowFiltersToSearch(next) })}
        onOpen={(flow) => void navigate({ to: '/flows/$flowId', params: { flowId: flow.id } })}
      />
    );
  },
});
